const filters = {
  1: [
    'buttonTag',
    'imageTag',
    'textbox', 
    'hotspot',
    'ptag',
    'hotdot'
  ]
}

export  function filteredTags(tags = [], filterName) {
  let filteredTags = []

  filteredTags = tags.filter(tag => {
    return filters[filterName].find(filter => {
      return filter === tag.template
    })
  })

  return filteredTags
}

export function getFilter(filterName) {
  return filters[filterName] || []
}